export const LIST_HEADER = /* GraphQL */ `
  query listHeaderQuery($filter: listHeaderFilterInput) {
    listHeader(filter: $filter) {
      id
      title
      description
      video
      image
      btnLabel
      btnUrl
      type
      createdAt
      updatedAt
    }
  }
`;